import posthog from "posthog-js";
import { omitEmpty, type AnalyticsProps } from "./props";

let ready = false;

export function initPostHog({
  apiKey,
  apiHost,
}: {
  apiKey?: string;
  apiHost?: string;
}) {
  if (!apiKey || typeof window === "undefined") return;
  try {
    posthog.init(apiKey, {
      api_host: apiHost || "https://us.i.posthog.com",
      capture_pageview: false,
      capture_pageleave: true,
      persistence: "localStorage+cookie",
    });
    ready = true;
  } catch {
    // never break UX for analytics
  }
}

export function track(event: string, properties?: AnalyticsProps) {
  if (!ready) return;
  try {
    posthog.capture(event, omitEmpty(properties));
  } catch {
    // ignore
  }
}

export function identify(userId: string, traits?: AnalyticsProps) {
  if (!ready) return;
  try {
    posthog.identify(userId, omitEmpty(traits));
  } catch {
    // ignore
  }
}

export function group(
  groupType: string,
  groupKey: string,
  traits?: AnalyticsProps
) {
  if (!ready) return;
  try {
    posthog.group(groupType, groupKey, omitEmpty(traits));
  } catch {
    // ignore
  }
}

export function page(name?: string, properties?: AnalyticsProps) {
  if (!ready) return;
  try {
    posthog.capture(
      "$pageview",
      omitEmpty({
        ...(name ? { page_name: name } : {}),
        ...properties,
      })
    );
  } catch {
    // ignore
  }
}

export function reset() {
  if (!ready) return;
  try {
    posthog.reset();
  } catch {
    // ignore
  }
}
